import {
	CaseTypes,
	HeroAboutUs,
	OurMission,
	WhyClaimMagic,
	Testimonial,
	Awards,
	OurTeam,
	Summary,
	ReadyToGetBanner,
} from '@/components/landing';

export const AboutUs: React.FC = () => {
	return (
		<div className="bg-[url('/img/landing/about-us/bubbles-hero-about-mobile.svg')] bg-[position:100%_-70px] lg:bg-[url('/img/landing/about-us/bubbles-hero-about.svg')] lg:bg-[position:100%_-120px] bg-no-repeat">
			<div className="space-y-6 pt-[50px] lg:pt-0">
				<HeroAboutUs />
				<OurMission />
			</div>
			<CaseTypes />
			<Summary />
			<Testimonial />
			<div className="bg-white">
				<Awards />
				<OurTeam />
				<WhyClaimMagic />
				<ReadyToGetBanner />
			</div>
		</div>
	);
};
